import * as React from 'react'
import { useHistory, useLocation } from 'react-router'

import { SmsVerificationModal } from './SmsVerificationModal'

import {
  formatTel,
  getRawPhoneNumberWithCountryCode
} from '@local/do-secundo-form-utils'
import {
  handleVerificationCodeSubmit,
  useTrackCodeSubmissionSuccess,
  useSendSmsCode,
  useImportAccount,
  useIsAccountLinkingEnabled,
  isLegacyAccountLoggedInForAccountLinking
} from '@local/do-secundo-passwordless-authentication'
import {
  useAuth,
  importSuccessToast
} from '../../../../client/components/AuthProvider/AuthProvider'

export interface PasswordlessCodeVerificationModalProps {
  onClose: () => void
}

export const PasswordlessCodeVerificationModal = ({
  onClose
}: PasswordlessCodeVerificationModalProps) => {
  const { authClient, setIsAuthenticated, passwordlessLogin } = useAuth()
  const handleImportAccount = useImportAccount()
  const history = useHistory()
  const { state } = useLocation<{
    from?: string
    guestPhone?: string
  }>()
  const ACCOUNT_LINKING_ENABLED = useIsAccountLinkingEnabled()
  const phone = state?.guestPhone

  useSendSmsCode(phone, authClient)

  if (!phone) {
    history.push('?mode=login')
  }

  const trackCodeSubmissionSuccess = useTrackCodeSubmissionSuccess()
  const from = state?.from
  return (
    <SmsVerificationModal
      onClose={onClose}
      handleSubmit={async (code: string) => {
        await handleVerificationCodeSubmit({
          code,
          onCodeSubmissionSuccess: onClose,
          trackCodeSubmissionSuccess: () => trackCodeSubmissionSuccess(from),
          completeProfileCreation: passwordlessLogin,
          from
        })

        if (
          ACCOUNT_LINKING_ENABLED &&
          isLegacyAccountLoggedInForAccountLinking()
        ) {
          await handleImportAccount({
            onSuccess: () => {
              importSuccessToast()
              onClose()
            }
          })
        }
        setIsAuthenticated(authClient?.isAuthenticated)
      }}
      numFields={6}
      phone={formatTel(phone!)}
      mainText={'Last step! Enter the code we texted to:'}
      handleResend={() =>
        authClient?.requestPasswordless(getRawPhoneNumberWithCountryCode(phone))
      }
    />
  )
}
